// src/components/stop/FrequencyInfo.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';

function FrequencyInfo({ frequency }) {
  return (
    <Box>
      <Typography variant="h6" gutterBottom fontWeight="medium">
        📊 Frequency & Timings
      </Typography>
      <Typography color="text.secondary">{frequency}</Typography>
    </Box>
  );
}

export default FrequencyInfo;
